import { useState, useEffect } from 'react';
import api from '../services/api';

interface DentalHealthStats {
  total_pathologies: number;
  prevention_rate: number;
  emergency_rate: number;
  regular_followup_rate: number;
  pathology_distribution: Array<{
    pathology_name: string;
    count: number;
    percentage: number;
    avg_severity?: number;
  }>;
  age_group_analysis: Array<{
    age_range: string;
    patient_count: number;
    treatment_count: number;
    avg_treatment_cost: number;
  }>;
  seasonal_pathology_trends: Array<{
    month: string;
    caries: number;
    gingivitis: number;
    urgencies: number;
    preventive: number;
  }>;
  epidemiology_profile: Array<{
    indicator: string;
    score: number;
  }>;
  hygiene_score: number;
  care_access_rate: number;
  avg_care_cost: number;
  severe_cases_rate: number;
}

export function useDentalHealthStats(dateRange: { start_date?: string; end_date?: string }) {
  const [data, setData] = useState<DentalHealthStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await api.get('/dashboard/dental-health-stats/', {
          params: dateRange
        });
        setData(response.data);
        setError(null);
      } catch (err) {
        setError('Erreur lors du chargement des statistiques de santé dentaire');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dateRange.start_date, dateRange.end_date]);

  return { data, isLoading, error };
}